import { render, staticRenderFns } from "./Meeting-pagination.vue?vue&type=template&id=1923ddf6"
import script from "./Meeting-pagination.vue?vue&type=script&lang=js"
export * from "./Meeting-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports